export default "__VITE_ASSET__B0y91s4n__"